
import Vue from "vue";

export default Vue.extend({
	name: "style-guide",
	props: {
		theme: String,
	},
	data() {
		return {
			radioVals: [
				"c",
				"c",
				"c",
				"c"
			],
			options: [
				{ value: "1", label: "Lord of the Rings" },
				{ value: "2", label: "Harry Potter" },
				{ value: "3", label: "Batman Begins" },
				{ value: "4", label: "Inception" },
				{ value: "5", label: "Captain America: First Avenger" },
				{ value: "6", label: "Captain Marvel" },
				{ value: "7", label: "Iron Man" },
				{ value: "8", label: "Iron Man 2" },
				{ value: "9", label: "Incredible Hulk" },
				{ value: "10", label: "Thor" },
				{ value: "11", label: "The Avengers" },
				{ value: "12", label: "Iron Man 3" },
				{ value: "13", label: "Thor: The Dark World" },
				{ value: "14", label: "Captain America: The Winter Soldier" },
				{ value: "15", label: "Guardians of the Galaxy" },
				{ value: "16", label: "Guardians of the Galaxy Vol. 2" },
				{ value: "17", label: "Avengers: Age of Ultron" },
				{ value: "18", label: "Ant-Man" },
				{ value: "19", label: "Avengers: Civil War" },
				{ value: "20", label: "Spider Man: Homecoming" },
				{ value: "21", label: "Doctor Strange" },
				{ value: "22", label: "Thor: Ragnarok" },
				{ value: "23", label: "Black Panther" },
				{ value: "24", label: "Ant-Man and the Wasp" },
				{ value: "25", label: "Avengers: Infinity War" },
				{ value: "26", label: "Avengers: End Game" }
			],
			selectedSingleEmpty: "",
			selectedMultiEmpty: [],
			selectedSingle: { value: "2", label: "Harry Potter" },
			selectedMulti: [
				{ value: "11", label: "The Avengers" },
				{ value: "10", label: "Thor" }
			],
			disabledSingle: { value: "5", label: "Captain America: First Avenger" },
			disabledMulti: [
				{ value: "7", label: "Iron Man" },
				{ value: "20", label: "Spider Man: Homecoming" }
			],
		};
	},
});
